import type { ContentObjectDetail, ContentObjectList, JournalNote } from 'models';
import { useMemo } from 'react';
import { routes } from 'routes/routes';
import { images } from 'common/utils';
import type { PillType } from '../content-object-header';

type P = {
  isMemberOfProgram: boolean;
  item: ContentObjectDetail | ContentObjectList | JournalNote;
};

export const useContentObjectPill = ({ isMemberOfProgram, item }: P): PillType | undefined =>
  useMemo(() => {
    if (item.contentableType === 'Program') {
      return {
        fallbackPhoto: images.default.programProfilePhoto,
        link: isMemberOfProgram ? routes.program.timeline(item.program.id) : routes.program.about(item.program.id),
        name: item.program.name,
        photoUrl: item.program.profilePhoto?.url,
      };
    }

    if (item.contentableType === 'Community') {
      const [community] = item.postInCommunities;

      return {
        fallbackPhoto: images.default.communityProfilePhoto,
        link: routes.community.feed(community.id),
        name: community.name,
        photoUrl: community.profilePhoto?.url,
      };
    }

    if (item.contentableType === 'Group') {
      return {
        fallbackPhoto: images.default.groupProfilePhoto,
        link: routes.group.detail.scope(item.group.id),
        name: item.group.name,
        photoUrl: item.group.logo?.url,
      };
    }

    return undefined;
  }, [isMemberOfProgram, item]);
